import { Evaluacion } from '@/hooks/useMain';
import { LuChevronRight } from 'react-icons/lu';

interface SurveyCardProps {
    isTouchDevice: boolean;
    item: Evaluacion;
    handleClick: (item: Evaluacion) => void;
}

const SurveyCardComponent = ({ item, handleClick, isTouchDevice }: SurveyCardProps) => {
	console.log(item);

    if (item) {
        return (
            <div
                onClick={() => handleClick(item)}
                className="flex cursor-pointer bg-default-50 items-center justify-between p-5 mb-0.5 shadow-sm transition-colors hover:bg-default-300"
            >
                <div className="flex-1">
                    <span className={`${isTouchDevice ? 'text-xl font-medium' : 'text-base'}`}>
                        {item.cDescripcion}
                    </span>
                </div>
                <LuChevronRight className={`${isTouchDevice ? 'text-xl' : 'text-base'}`} />
            </div>
        );
    }

    return <div className="h-18" />;
};

export default SurveyCardComponent;
